export enum TalkViewerTypeVo {
  Tap = 'TAP',
  TapScroll = 'TAP_SCROLL',
}
